export const COPYRIGHT_LINE = "\u00a9 LabTrack by Pathlete India Pvt. Ltd., 2026. All Rights Reserved.";

export const Footer = () => (
  <div className="mt-10 pt-6 border-t border-[#E5E7EB] text-center text-xs text-[#6B7280]"
    data-testid="app-footer">
    <p>Proudly developed in India by PathLete Technologies</p>
    <p className="mt-1" data-testid="app-copyright">{COPYRIGHT_LINE}</p>
  </div>
);
